import { setAlert } from "./alert";
import {
  GET_NOTIFICATION_TEMPLATES_REQUEST,
  GET_NOTIFICATION_TEMPLATES_SUCCESS,
  GET_NOTIFICATION_TEMPLATES_FAILURE,
  GET_NOTIFICATION_TEMPLATE_SUCCESS,
  CREATE_NOTIFICATION_TEMPLATE_REQUEST,
  CREATE_NOTIFICATION_TEMPLATE_SUCCESS,
  CREATE_NOTIFICATION_TEMPLATE_FAILURE,
  UPDATE_NOTIFICATION_TEMPLATE_REQUEST,
  UPDATE_NOTIFICATION_TEMPLATE_SUCCESS,
  UPDATE_NOTIFICATION_TEMPLATE_FAILURE,
  DELETE_NOTIFICATION_TEMPLATE_REQUEST,
  DELETE_NOTIFICATION_TEMPLATE_SUCCESS,
  DELETE_NOTIFICATION_TEMPLATE_FAILURE,
  SET_NOTIFICATION_TEMPLATE_SEARCH,
  CLEAR_SELECTED_NOTIFICATION_TEMPLATE,
} from "./types";
import { notificationTemplateService } from "../services/notificationTemplate.service";

export const setNotificationTemplateSearch = (search) => ({
  type: SET_NOTIFICATION_TEMPLATE_SEARCH,
  payload: search,
});

export const clearSelectedNotificationTemplate = () => ({
  type: CLEAR_SELECTED_NOTIFICATION_TEMPLATE,
});

export const getNotificationTemplates = (filters = {}) => async (dispatch) => {
  dispatch({ type: GET_NOTIFICATION_TEMPLATES_REQUEST });
  const result = await notificationTemplateService.getTemplates(filters);
  if (result.success) {
    dispatch({ type: GET_NOTIFICATION_TEMPLATES_SUCCESS, payload: result.data || [] });
    return result;
  }
  dispatch({ type: GET_NOTIFICATION_TEMPLATES_FAILURE, payload: result.message });
  dispatch(setAlert(result.message || "Failed to fetch templates", "danger"));
  return result;
};

export const getNotificationTemplateById = (templateId) => async (dispatch) => {
  const result = await notificationTemplateService.getTemplateById(templateId);
  if (result.success) {
    dispatch({ type: GET_NOTIFICATION_TEMPLATE_SUCCESS, payload: result.data });
    return result;
  }
  dispatch(setAlert(result.message || "Failed to load template", "danger"));
  return result;
};

export const createNotificationTemplate = (payload) => async (dispatch) => {
  dispatch({ type: CREATE_NOTIFICATION_TEMPLATE_REQUEST });
  const result = await notificationTemplateService.createTemplate(payload);
  if (result.success) {
    dispatch({ type: CREATE_NOTIFICATION_TEMPLATE_SUCCESS, payload: result.data });
    dispatch(setAlert(result.message || "Template created successfully.", "success"));
    return result;
  }
  dispatch({ type: CREATE_NOTIFICATION_TEMPLATE_FAILURE, payload: result.message });
  dispatch(setAlert(result.message || "Failed to create template", "danger"));
  return result;
};

export const updateNotificationTemplate = (templateId, payload) => async (dispatch) => {
  dispatch({ type: UPDATE_NOTIFICATION_TEMPLATE_REQUEST });
  const result = await notificationTemplateService.updateTemplate(templateId, payload);
  if (result.success) {
    dispatch({ type: UPDATE_NOTIFICATION_TEMPLATE_SUCCESS, payload: result.data });
    dispatch(setAlert(result.message || "Template updated successfully.", "success"));
    return result;
  }
  dispatch({ type: UPDATE_NOTIFICATION_TEMPLATE_FAILURE, payload: result.message });
  dispatch(setAlert(result.message || "Failed to update template", "danger"));
  return result;
};

export const deleteNotificationTemplate = (templateId) => async (dispatch) => {
  dispatch({ type: DELETE_NOTIFICATION_TEMPLATE_REQUEST });
  const result = await notificationTemplateService.deleteTemplate(templateId);
  if (result.success) {
    dispatch({ type: DELETE_NOTIFICATION_TEMPLATE_SUCCESS, payload: { id: templateId } });
    dispatch(setAlert(result.message || "Template deleted successfully.", "success"));
    return result;
  }
  dispatch({ type: DELETE_NOTIFICATION_TEMPLATE_FAILURE, payload: result.message });
  dispatch(setAlert(result.message || "Failed to delete template", "danger"));
  return result;
};
